import * as React from 'react';
import {
    AutocompleteInput,
    DateInput,
    ReferenceInput,
    SearchInput,
    SelectInput,
} from 'react-admin';



const businessCardFilters = [
    <SearchInput source="q" alwaysOn />,
    <SelectInput
        source="status"
        choices={[
            { id: 'DRAFT', name: 'DRAFT' },
            { id: 'PUBLISHED', name: 'PUBLISHED' }
        ]}
    />,
    // <ReferenceInput source="customer_id" reference="customers">
    //     <AutocompleteInput
    //         optionText={(choice?: Customer) =>
    //             choice?.id // the empty choice is { id: '' }
    //             ? `${choice.first_name} ${choice.last_name}`
    //             : ''
    //         }
    //     />
    // </ReferenceInput>,
    // <ReferenceInput source="product_id" reference="products">
    //     <AutocompleteInput optionText="reference" />
    // </ReferenceInput>,
    // <DateInput source="date_gte" />,
    // <DateInput source="date_lte" />,
];

export default businessCardFilters;